











import { Component, Prop, Ref, Vue } from 'vue-property-decorator'
import BuilderTooltip from '@/components/builder/BuilderTooltip.vue'
import BuilderButton from '@/components/builder/BuilderButton.vue'
import BuilderAddButton from '@/components/builder/BuilderAddButton.vue'
import { ProfileStubState } from './BuilderProfile.vue'
import BuilderDot from "@/components/builder/BuilderDot.vue"

@Component({
  components: {
    BuilderAddButton,
    BuilderButton,
    BuilderTooltip,
    BuilderDot
  },
})
export default class BuilderProfileAddProduct extends Vue {
  @Prop({ required: true, type: Object }) readonly value!: ProfileStubState

  @Prop({ required: true, type: Number }) readonly step!: number

  @Ref('file') readonly fileInput!: HTMLInputElement

  get isNextStepDisabled(): boolean {
    return !this.appType
  }


  get appType(): string {
    return this.$store.getters['builder/getAppType']
  }

  set appType(value: string) {
    this.$store.commit("builder/setAppType", value)
  }

  async onNextClick(): Promise<void> {
    this.$emit('next')
  }

  async mounted(): Promise<void> {
    this.$emit('input', {
      highlight: 'appType',
      blurCover: false,
      blurSubscriptions: false,
      blurContentType: false,
      blurPosts: false
    })
  }
}
